import { useDispatch, useSelector } from "react-redux";
import { login } from "./authSlice";
import { useState } from "react";
import { Navigate } from "react-router-dom";

export default function LoginPage() {
    const dispatch = useDispatch();
    const { token, loading, error } = useSelector((state) => state.auth);

    const [form, setForm] = useState({
        email: "",
        password: "",
    });


    if (token) return <Navigate to="/admin/dashboard" />;

    //console.log("LoginPage render, token:", token);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(login(form));
    };


    return (
        <div className="h-screen flex items-center justify-center bg-gray-100">
            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded-xl shadow-md w-96"
            >
                <h2 className="text-2xl font-bold mb-6 text-center">
                    Warehouse App
                </h2>

                {error && (
                    <div className="bg-red-100 text-red-600 p-2 mb-4 rounded">
                        {error}
                    </div>
                )}

                <input
                    type="email"
                    placeholder="Email"
                    className="w-full border p-2 mb-4 rounded"
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                />

                <input
                    type="password"
                    placeholder="Password"
                    className="w-full border p-2 mb-4 rounded"
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                />

                <button
                    className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                    disabled={loading}
                >
                    {loading ? "Loading..." : "Login"}
                </button>
            </form>
        </div>
    );
}